import React from "react";
import { Box, TableContainer } from "@mui/material";

interface GradientBorderTableContainerProps {
  children: React.ReactNode;
}

export const GradientBorderTableContainer: React.FC<GradientBorderTableContainerProps> = ({ children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        background: "linear-gradient(to bottom, #a8a8d4, #ffffff)",
        padding: "3px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#eeffb2",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <TableContainer
          sx={{
            backgroundColor: "transparent",
            overflowX: "auto",
            "& .MuiTable-root": {
              backgroundColor: "transparent",
            },
          }}
        >
          {children}
        </TableContainer>
      </Box>
    </Box>
  );
};
